import { createFileRoute } from "@tanstack/react-router"

import { Button } from "../components/Button.tsx"
import { IconButton } from "../components/IconButton.tsx"
import { Menu } from "../components/Menu.tsx"

export const Route = createFileRoute("/ui")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="space-y-2 p-4">
      <h1 className="font-bold text-2xl">Component Reference</h1>
      <h2 className="font-bold text-xl">Button</h2>
      <div className="flex gap-2">
        <Button size="xsmall">
          <OcticonMarkGithub16 />
          Button
        </Button>
        <Button size="small">
          <OcticonMarkGithub16 />
          Button
        </Button>
        <Button>
          <OcticonMarkGithub16 />
          Button
        </Button>
        <Button size="large">
          <OcticonMarkGithub16 />
          Button
        </Button>
        <Button variant="primary">Button</Button>
        <Button variant="invisible">Button</Button>
      </div>

      <h2 className="font-bold text-xl">IconButton</h2>
      <div className="flex gap-2">
        <IconButton icon={OcticonMarkGithub16} size="xsmall" />
        <IconButton icon={OcticonMarkGithub16} size="small" />
        <IconButton icon={OcticonMarkGithub16} />
        <IconButton icon={OcticonMarkGithub16} size="large" />
      </div>

      <h2 className="font-bold text-xl">Menu</h2>
      <Menu>
        <Menu.Button render={<Button />}>Trigger</Menu.Button>
        <Menu.Menu>
          <Menu.Group>
            <Menu.GroupLabel>Group 1</Menu.GroupLabel>
            <Menu.Item>Item 1</Menu.Item>
            <Menu.Item>Item 2</Menu.Item>
          </Menu.Group>
          <Menu.Separator />
          <Menu.Group>
            <Menu.GroupLabel>Group 2</Menu.GroupLabel>
            <Menu.Item>Item 1</Menu.Item>
            <Menu.Item active>Item 2</Menu.Item>
            <Menu.Item>Item 3</Menu.Item>
            <Menu.Item>Item 4</Menu.Item>
          </Menu.Group>
        </Menu.Menu>
      </Menu>
    </div>
  )
}
